export const TRANSLATION_SCOPE = 'classroom'